import PropTypes from 'prop-types';

function IFOurBrandsInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47786)">
                <path
                    d="M12.8319 1.05336L3.31486 9.74974C2.76873 10.2488 2.73055 11.096 3.22959 11.6422L15.5809 25.1591C16.08 25.7053 16.9272 25.7435 17.4734 25.2444L26.9904 16.548C27.5366 16.049 27.5748 15.2017 27.0757 14.6556L14.7244 1.13863C14.2253 0.592501 13.3781 0.554323 12.8319 1.05336Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.7618 1.36472L9.64201 5.75922C8.94652 6.01139 8.58715 6.77962 8.83932 7.47511L15.0808 24.6887C15.3329 25.3842 16.1012 25.7436 16.7967 25.4914L28.9165 21.0969C29.612 20.8447 29.9713 20.0765 29.7192 19.381L23.4777 2.16741C23.2256 1.47192 22.4573 1.11255 21.7618 1.36472Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M30.658 5.32027L17.7951 4.4569C17.0569 4.40735 16.4184 4.96556 16.3688 5.70369L15.1426 23.9728C15.0931 24.7109 15.6513 25.3495 16.3894 25.399L29.2524 26.2624C29.9905 26.3119 30.6291 25.7537 30.6786 25.0156L31.9048 6.74649C31.9544 6.00836 31.3962 5.36982 30.658 5.32027Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.4859 13.2184C23.213 12.8605 22.8657 12.1376 21.8062 12.2332C20.7501 12.3254 19.8004 13.2751 19.8678 14.4658C19.9351 15.66 20.5871 16.7266 21.4518 17.5311C22.3165 18.3355 22.9543 18.7146 23.2449 18.8032C23.5461 18.7288 25.2187 17.9138 25.9558 16.9995C26.6965 16.0817 27.4477 15.3517 26.9977 13.7216C26.5476 12.0915 24.6092 12.414 24.3683 12.6266C24.1273 12.8392 23.4859 13.2149 23.4859 13.2149V13.2184Z"
                    fill="#F8F2ED"
                    stroke="#453D3D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47786">
                    <rect width="35.4794" height="29.5224" fill="white" transform="translate(0.281799 0.351562)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default IFOurBrandsInactive;

IFOurBrandsInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFOurBrandsInactive.defaultProps = {
    className: null,
    width: 28,
};
